import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';

export const collectibleSelect = (state: RootState) => state.features.nfts.nft;

export const selectCurrentBids = createSelector(
    collectibleSelect,
    (collectible) => collectible?.currentBids
);

export const selectAuctionWinner = createSelector(
    collectibleSelect,
    (collectible) => collectible?.auctionWinner
);

export const selectCollectible = createSelector(
    collectibleSelect,
    (state) => state.nft
);

export const selectCollectibleCreated = createSelector(
    collectibleSelect,
    (collectible) => collectible?.created
);
export const selectCollectibleError = createSelector(
    collectibleSelect,
    (collectible) => collectible?.error
);
export const selectCollectiblePublished = createSelector(
    selectCollectible,
    (collectible) => collectible && collectible.isPublished
);

export const selectAllLots = createSelector(
    collectibleSelect,
    (collectible) => collectible?.allLots?.lots ?? []
);

export const selectSelectedLot = createSelector(
    collectibleSelect,
    (collectible) => collectible?.selectedLot
);

export const selectActiveOwners = createSelector(
    collectibleSelect,
    (collectible) => collectible?.activeOwners ?? []
);

export const selectActiveLots = createSelector(
    collectibleSelect,
    (collectible) => collectible?.activeLots ?? []
);

export const selectNftCollection = createSelector(
    collectibleSelect,
    (collectible) => collectible?.collection
);

export const selectNftHistory = createSelector(
    collectibleSelect,
    (collectible) => collectible?.history
);

export const selectSelectedLaunchpadId = createSelector(
    collectibleSelect,
    (collectible) => collectible?.selectedLaunchpadId
);
